/**
 * 功能引导「是否已看过」标记
 *
 * 用于「新页面/新功能首次提示」类引导：同一个用户在本浏览器看过一次后，
 * 之后不再打扰。仅做轻量本地记忆（清缓存或换浏览器会重新出现）。
 */

const FEATURE_TOUR_STORAGE_PREFIX = "flyMeta_feature_tour_seen_";

function buildKey(tourId) {
    return `${FEATURE_TOUR_STORAGE_PREFIX}${tourId}`;
}

export function hasSeenFeatureTour(tourId) {
    if (!tourId) {
        return true;
    }

    try {
        return localStorage.getItem(buildKey(tourId)) === "1";
    } catch {
        // 读取异常时按「未看过」处理也会反复打扰，这里按「已看过」更保守，避免异常环境下骚扰用户
        return true;
    }
}

export function markFeatureTourSeen(tourId) {
    if (!tourId) {
        return;
    }

    try {
        localStorage.setItem(buildKey(tourId), "1");
    } catch {
        // 忽略 localStorage 异常，避免影响主流程
    }
}
